export default {
  props: ["headers", "items", "noDataText"],
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10
  }),
  methods: {
    async nextPage() {
      const pages = Math.ceil(this.items.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  }
};
